import z from 'zod';

import { type DefaultListingUrl } from '@/features/listing/types/listing-types';

export const placeBoundingBoxSchema = z.object({
  latitudeNorthEast: z.number(),
  latitudeSouthWest: z.number(),
  longitudeNorthEast: z.number(),
  longitudeSouthWest: z.number(),
});

export const coordinatesSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
});

export const placeSchema = z.object({
  bbox: placeBoundingBoxSchema,
  fullName: z.string(),
  geometry: z.object({ coordinates: coordinatesSchema }),
  id: z.string(),
});

export interface Place {
  id: string,
  fullName: string,
  bbox: PlaceBoundingBox,
  geometry: {
    coordinates: Coordinates
  }
}

export interface PlaceBoundingBox {
  latitudeNorthEast: number,
  latitudeSouthWest: number,
  longitudeNorthEast: number,
  longitudeSouthWest: number
}

export interface Coordinates {
  latitude: number;
  longitude: number
}

export interface CurrentPlace extends Place {
  listingTypeUrl: DefaultListingUrl,
}

export interface CountryWithPhoneCode {
  id: number,
  name: string,
  phoneCode: string,
  shortName: string,
}

export enum SitemapsPlacesLevel {
  Countries = 'countries',
  Cities = 'cities',
}

export interface SitemapsCountries {
  level: SitemapsPlacesLevel.Countries,
  count: number,
  pageNumber: number,
  pageSize: number,
  items: string[],
}

export interface City {
  title: string,
  loc: string,
}

export interface SitemapsCities {
  level: SitemapsPlacesLevel.Cities,
  countryName: string,
  items: City[],
  count: number,
  pageNumber: number,
  pageSize: number,
}

export type SitemapsPlaces = SitemapsCountries | SitemapsCities;
